<template>
  <div class="d-block d-md-none">{{ column }}</div>
  <div class="d-block justify-content-between d-md-flex">
    <div>
      <div v-if="!item.empty && item.text" class="d-flex flex-column">
        <span class="fw-bold d-flex align-items-center">{{ item.text }} </span>
        <span v-if="item.baseline" class="dataTable__baseline">{{ item.baseline }} </span>
      </div>
      <div v-else class="dataTable__empty">{{ item.empty ?? $t("global.empty.no_data_available") }}</div>
    </div>
    <div v-if="actions && actions.length">
      <template v-for="(action, index) in actions" :key="index">
        <IconButtonComponent
          v-if="action.action && action.icon"
          :icon="action.icon"
          :tooltip="action.tooltip"
          @buttonClick="emitRowAction(action, item)"
        />
      </template>
    </div>
  </div>
</template>

<script>
import IconButtonComponent from "@/components/utils/buttons/IconButtonComponent.vue";

export default {
  name: "TextCellDataTableComponent",
  components: { IconButtonComponent },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: String,
      required: false,
      default: null,
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["emitRowAction", "deleteItem"],
  methods: {
    emitRowAction(action, item) {
      this.$emit("emitRowAction", { action: action.action, item: item });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-icon {
  svg {
    width: 15px;
    height: 15px;
  }

  &.danger {
    color: $red;
  }
}
</style>
